import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as clusterReducer from "containers/ClusterChart/reducer";

import ClusterChart from "components/ClusterChart/ClusterChart";
import InitClusterChart from "components/ClusterChart/InitClusterChart";

class ClusterChartContainer extends React.PureComponent {
  render() {
    const { dataset } = this.props;

    if (dataset && dataset.rulefit && dataset.rulefit.length === 0) {
      return <InitClusterChart {...this.props} />;
    }

    return <ClusterChart {...this.props} cData={dataset ? dataset.rulefit : []} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.datasetId ? ownProps.datasetId : ownProps.id;

  return {
    updateSelected: (selected) => dispatch(clusterReducer.updateSelected(id, selected)),
    updateHover: (hover) => dispatch(clusterReducer.updateHover(id, hover)),

    updateRunPlotType: (type) => dispatch(runReducer.updateRunPlotType(id, type)),

    initCluster: (datasetId) => dispatch(clusterReducer.initCluster(datasetId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.datasetId ? ownProps.datasetId : ownProps.id;

  return {
    dataset: ownProps.datasetId
      ? homeReducer.getDataset(state, ownProps.datasetId)
      : setupReducer.getDatasetFromSetup(state, ownProps.id),

    selected: clusterReducer.getSelected(state, id),
    hover: clusterReducer.getHover(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ClusterChartContainer);
